export default __webpack_public_path__ + "static/media/HotSale-Nova.ecd1b5a4.png";